import { defineComponent as _defineComponent } from 'vue';
import { debounce } from 'lodash';
export default /*#__PURE__*/_defineComponent({
  __name: 'card-loading',
  emits: ['intersect'],
  setup(__props, {
    emit
  }) {
    const emitIntersect = debounce(entries => {
      if (entries[0].isIntersecting) {
        emit('intersect');
      }
    }, 500);
    return {
      __sfc: true,
      emit,
      emitIntersect
    };
  }
});